import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSearch = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#1A1A1A",
		d: "M16.336 14.566C19.06 11.392 18.694 6.74 15.5 3.99c-3.193-2.751-8.09-2.635-11.134.265-3.045 2.9-3.167 7.563-.279 10.604 2.889 3.04 7.773 3.39 11.107.795l6.429 6.123c.315.3.825.299 1.14-.001a.743.743 0 0 0 0-1.086l-6.428-6.123zm-2.19-.083c-2.673 2.06-6.573 1.767-8.874-.668-2.302-2.435-2.199-6.16.234-8.476 2.432-2.317 6.343-2.415 8.9-.223 2.556 2.191 2.865 5.906.701 8.453a6.357 6.357 0 0 1-.96.914z"
	})
});
export default SvgSearch;
